// Components==============
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { useRedux } from 'hooks/useRedux';
import React, { createContext, useRef, useState } from 'react';
import { ThemeWithProjects } from 'typings';
import Shade from '../Shade/Shade';
import Card from './components/Card/Card';
import ProjectModal from './components/ProjectModal/ProjectModal';
import ThemeModal from './components/ThemeModal/ThemeModal';
import './ProjectCard.module.scss';
// =========================

type ProjectCardContextType = {
  theme?: ThemeWithProjects;
  themeModalIsOpen: boolean;
  setThemeModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  categories: (CategoryEntity | undefined)[] | undefined;
  withModal?: boolean;
  showProjectModal: boolean;
  themeModalRef: React.RefObject<HTMLDivElement>;
  projectModalRef: React.RefObject<HTMLDivElement>;
  completed?: boolean;
  register?: boolean;
};

export const ProjectCardContext = createContext({} as ProjectCardContextType);

export default function ProjectCard({
  theme,
  withModal,
  completed,
  register,
  style,
}: {
  theme?: ThemeWithProjects;
  withModal?: boolean;
  completed?: boolean;
  register?: boolean;
  style?: React.CSSProperties;
}) {
  const [themeModalIsOpen, setThemeModalIsOpen] = useState(false);

  const categories = useRedux((state) =>
    state.category?.entities.allIds.map(
      (id) => state.category?.entities.byId[id]
    )
  );

  const showProjectModal = theme?.allProjects
    ? theme?.allProjects.length > 0
    : false;

  const themeModalRef = useRef<HTMLDivElement>(null);
  const projectModalRef = useRef<HTMLDivElement>(null);

  useOnClickOutside({
    refs: [themeModalRef, projectModalRef],
    handler: () => setThemeModalIsOpen(false),
    condition: themeModalIsOpen && showProjectModal,
  });

  return (
    <ProjectCardContext.Provider
      value={{
        theme,
        themeModalIsOpen,
        setThemeModalIsOpen,
        categories,
        withModal,
        showProjectModal,
        themeModalRef,
        projectModalRef,
        completed,
        register,
      }}
    >
      <Card style={{ ...style }} />
      {withModal && themeModalIsOpen && (
        <>
          <div
            styleName={
              showProjectModal && themeModalIsOpen ? 'modal-wrapper' : 'fixed'
            }
          >
            {themeModalIsOpen && <ThemeModal />}
            {showProjectModal && <ProjectModal />}
          </div>
          {showProjectModal && themeModalIsOpen && <Shade />}
        </>
      )}
    </ProjectCardContext.Provider>
  );
}
